import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-678159e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Awards", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Our Software Awards", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Awards", -1))
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "pa-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_timeline, {
                      align: "start",
                      side: _ctx.isMobile ? 'end' : undefined
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.awardsList, (year, i) => {
                          return (_openBlock(), _createBlock(_component_v_timeline_item, {
                            key: i,
                            "dot-color": year.color,
                            size: "small"
                          }, {
                            opposite: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(`pt-1 headline font-weight-bold text-${year.color}`),
                                textContent: _toDisplayString(year.date)
                              }, null, 10, _hoisted_4)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass([{'text-right': (i % 2) && !_ctx.isMobile}])
                              }, [
                                _createElementVNode("h1", _hoisted_5, _toDisplayString(year.subTitle), 1),
                                _createElementVNode("h4", {
                                  class: _normalizeClass(`mt-n1 headline font-weight-light mb-4 text-${year.color}`),
                                  style: {"white-space":"pre"}
                                }, _toDisplayString(year.title), 3),
                                _createElementVNode("h1", null, _toDisplayString(year.description), 1)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["dot-color"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["side"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}